import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './App.css';

import PageHome from './pages/PageHome/PageHome';
import Page404 from "./pages/Page404/Page404";
import PageProgram from "./pages/PageProgram/PageProgram";
import PageAbout from "./pages/PageAbout/PageAbout";
import PageContact from "./pages/PageContact/PageContact";
import PageJoin from "./pages/PageJoin/PageJoin";

import Header from "./components/Header/Header";
import Background from "./components/Background/Background";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Background />
        <div className="RouteContent">
          <Routes>
          <Route path="/" element={
              <div>
                <Helmet>
                  <title>Home | CodeAblaze</title>
                  <meta name="description" content="CodeAblaze - Blazing the Path for Equal Opportunity and Rising Coders" />
                </Helmet>
                <PageHome />
              </div>
            } />
            <Route path="/program" element={
              <div>
                <Helmet>
                  <title>Program | CodeAblaze</title>
                  <meta name="description" content="CodeAblaze - Blazing the Path for Equal Opportunity and Rising Coders" />
                </Helmet>
                <PageProgram />
              </div>
            } />
            <Route path="/about" element={
              <div>
                <Helmet>
                  <title>About | CodeAblaze</title>
                  <meta name="description" content="CodeAblaze - Blazing the Path for Equal Opportunity and Rising Coders" />
                </Helmet>
                <PageAbout />
              </div>
            } />
            <Route path="/contact" element={
              <div>
                <Helmet>
                  <title>Contact | CodeAblaze</title>
                  <meta name="description" content="CodeAblaze - Blazing the Path for Equal Opportunity and Rising Coders" />
                </Helmet>
                <PageContact />
              </div>
            } />
            <Route path="/join" element={
              <div>
                <Helmet>
                  <title>Join | CodeAblaze</title>
                  <meta name="description" content="CodeAblaze - Blazing the Path for Equal Opportunity and Rising Coders" />
                </Helmet>
                <PageJoin />
              </div>
            } />
            <Route path="*" element={
              <div>
                <Helmet>
                  <title>404 | CodeAblaze</title>
                  <meta name="description" content="Page Not Found" />
                </Helmet>
                <Background />
                <Page404 />
              </div>
            } />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
